<template>
  <nav class="block">
    <button @click="back">
      <font-awesome-icon icon="arrow-left" />
      <span>前のページに戻る</span>
    </button>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import router from '@/router';

export default defineComponent({
  name: 'BackButton',
  methods: {
    back() {
      router.back();
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/assets/const.scss' as *;

.block {
  z-index: 3;
  position: fixed;
  display: flex;
  align-items: center;
  top: 10px;
  left: 10px;
  height: 34px;
  @media (min-width: $tablet) {
    left: 20px;
  }
  @media (min-width: $desktop) {
    z-index: 1;
    position: absolute;
    height: auto;
    padding: 0;
  }

  button {
    padding: 0 5px;

    span {
      display: none;
      margin-left: 5px;

      @media (min-width: $desktop) {
        display: unset;
      }
    }
  }
}
</style>